/**
 * Claude via Supabase Edge `claude-proxy` (ANTHROPIC_API_KEY server-side only).
 * Never put Anthropic keys in REACT_APP_* — they ship in the CRA bundle.
 */
import { getSupabase, isSupabaseConfigured } from './supabase';

/**
 * @param {string} prompt
 * @param {number} [maxTokens=1000]
 * @returns {Promise<string>}
 */
export async function claudeUserMessage(prompt, maxTokens = 1000) {
  if (!isSupabaseConfigured) {
    throw new Error('NO_KEY');
  }
  const sb = getSupabase();
  if (!sb) {
    throw new Error('NO_KEY');
  }

  const { data, error } = await sb.functions.invoke('claude-proxy', {
    body: { prompt, maxTokens },
  });

  if (error) {
    const msg = String(error.message || error);
    if (/unauthorized|401|not authenticated/i.test(msg)) {
      throw new Error('NO_KEY');
    }
    throw new Error(msg || 'HTTP_ERROR');
  }

  if (data?.error) {
    const err = String(data.error);
    if (err === 'missing_anthropic_key' || err === 'unauthorized') {
      throw new Error('NO_KEY');
    }
    throw new Error(err);
  }

  const text = data?.text;
  if (typeof text === 'string' && text.trim()) return text.trim();
  throw new Error('EMPTY');
}

export function isClaudeConfigured() {
  return Boolean(isSupabaseConfigured);
}
